import React from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import indexOf from 'lodash/indexOf';
import classnames from 'classnames';
import { ExhibitorFeatures } from '../Constants';
import Classes from './../Classes';

const isPartOfExhibitorFeatures = (featureNameKey) => {
  const featureKeys = values(ExhibitorFeatures);
  return indexOf(featureKeys, featureNameKey) > -1;
};

const Label = ({
  featureNameKey, translations, exhibitorId, prefix
}) => {
  const featurePrefix = prefix ? <span className={'label-prefix'}>{prefix} </span> : '';
  if (!isPartOfExhibitorFeatures(featureNameKey)) {
    return (
        <span
          className={classnames(Classes.features)}
          data-dtm={`Custom ${featureNameKey}`}
          data-dtm-attributes={JSON.stringify({ exhibitorId })}
        >{featurePrefix}{featureNameKey}</span>
    );
  }
  return (
      <span
        className={classnames(Classes.features)}
      >{featurePrefix}{translations[featureNameKey]}</span>
  );
};

Label.propTypes = {
  featureNameKey: PropTypes.any.isRequired,
  tags: PropTypes.object.isRequired,
  exhibitorId: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  prefix: PropTypes.string,
};

export default Label;
